import classNames from 'classnames';
import React from 'react';

const WorldMap = ({ data, className }) => (
    <div className={classNames(className)}>
        <img src="/img/worldmap/WorldMap.svg" alt="World map" />
    </div>
    );

export default WorldMap;